// extracted by mini-css-extract-plugin
module.exports = {"typeTag":"TypeTag_typeTag__ogcuP","string":"TypeTag_string__2Xg4A","boolean":"TypeTag_boolean__EwUZh","number":"TypeTag_number__2TMiT"};